import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import IconListItemNodeView from './IconListItemNodeView.vue'
import { ICON_LIST_ICONS, DEFAULT_ICON } from './iconListIcons'

export const IconListItemNode = Node.create({
  name: 'iconListItem',

  content: 'inline*',

  marks: 'bold italic strike underline link',

  defining: true,

  addAttributes() {
    return {
      icon: {
        default: DEFAULT_ICON,
        parseHTML: element => {
          const value = element.getAttribute('data-icon')
          return value && ICON_LIST_ICONS[value] ? value : DEFAULT_ICON
        },
        renderHTML: attributes => ({ 'data-icon': attributes.icon }),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'li[data-type="icon-list-item"]',
        contentElement: 'div',
      },
    ]
  },

  renderHTML({ HTMLAttributes, node }) {
    const iconSpec = ICON_LIST_ICONS[node.attrs.icon] || ICON_LIST_ICONS[DEFAULT_ICON]
    return [
      'li',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'icon-list-item',
        style: 'display:flex;align-items:flex-start;gap:8px;margin-bottom:14px;',
      }),
      [
        'svg',
        {
          width: '20',
          height: '20',
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: 'currentColor',
          'stroke-width': '2',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          style: 'flex-shrink:0;margin-top:2px;',
        },
        ...iconSpec.svg,
      ],
      ['div', {}, 0],
    ]
  },

  addNodeView() {
    return VueNodeViewRenderer(IconListItemNodeView)
  },
})

export default IconListItemNode
